export const YML_FILE_NAME = 'bitbucket-pipelines.yml';
